import React, { useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import NavBar from './NavBar';
import Calendar from './Calendar';
import Map from './Map';

function App() {

  const navigate = useNavigate();
  const location = useLocation();


  return (
    <div className="App">
      <NavBar />
      <div className="Base_container">
       
        
        
        {/* Render the appropriate filter component based on the route */}
        <Routes>
          <Route path="/" element={<Map />} />
          <Route path="/Calendar" element={<Calendar />} />

          {/* Add more routes for other filters if needed */}
        </Routes>
      </div>
      {/* Other components or elements */}
    </div>
  );
}

export default App;
